// frontend/src/components/bd/bubbles/wrap.js
// Découpe un texte en lignes tenant dans maxWidthPx, via une fonction de mesure
// injectable (canvas measureText en prod, stub en test).
import { boxHeightPx, maxFontFor, minFontFor } from "./svgBuilder";

export function wrapText(text, maxWidthPx, measure) {
  const words = String(text).split(/\s+/).filter(Boolean);
  if (words.length === 0) return [""];
  const lines = [];
  let cur = "";
  for (const word of words) {
    const candidate = cur ? `${cur} ${word}` : word;
    // si cur est vide, on accepte le mot même s'il dépasse maxWidthPx
    // (mot unique trop long — aucun découpage possible).
    if (cur && measure(candidate) > maxWidthPx) {
      lines.push(cur);
      cur = word;
    } else {
      cur = candidate;
    }
  }
  if (cur) lines.push(cur);
  return lines;
}

// Mesureur canvas réel (prod). Police = mêmes FONT_FAMILY/FONT_SIZE que le builder.
export function canvasMeasurer(fontPx, fontFamily) {
  const cv = document.createElement("canvas");
  const ctx = cv.getContext("2d");
  ctx.font = `${fontPx}px ${fontFamily}`;
  return (s) => ctx.measureText(s).width;
}

// Plus grande police ∈ [min,max] du kind telle que le texte wrappé tienne sous
// maxHeightPx. Miroir EXACT de _fit_font_size (backend/bd/bubbles/placement.py).
// measureFactory(size) -> mesureur | falsy (pas de wrap -> une seule ligne).
export function fitFontSize(text, kind, boxWidthPx, maxHeightPx, measureFactory) {
  const maxF = maxFontFor(kind), minF = minFontFor(kind);
  const single = (size) => {
    const hasWords = String(text).split(/\s+/).filter(Boolean).length > 0;
    return { fontSize: size, lines: hasWords ? [String(text)] : [""] };
  };
  for (let size = maxF; size >= minF; size--) {
    const measure = measureFactory(size);
    if (!measure) return single(size);
    const lines = wrapText(text, boxWidthPx, measure);
    if (boxHeightPx(lines.length, kind, size) <= maxHeightPx) return { fontSize: size, lines };
  }
  const measure = measureFactory(minF);
  if (!measure) return single(minF);
  return { fontSize: minF, lines: wrapText(text, boxWidthPx, measure) };
}
